import Layout from '@/layout'
const automaticShelvingRouter = {
  path: '/AutomaticShelving',
  component: Layout,
  redirect: '/AutomaticShelving/AutomaticShelvingList',
  name: 'AutomaticShelving',
  alwaysShow: true,
  meta: {
    title: '自动化',
    icon: 'Output'
    // icon: 'AutomaticShelving'
  },
  children: [
    {
      path: '/AutomaticShelving/AutomaticShelvingList',
      name: "AutomaticShelvingList",
      component: () => import("@/views/automaticShelving/automaticShelvingList/index.vue"),
      meta: {
        title: "上架任务",
      }
    },
    {
      path: '/AutomaticShelving/seckillActivity',
      name: "seckillActivity",
      component: () => import("@/views/automaticShelving/seckillActivity/index.vue"),
      meta: {
        title: "秒杀活动",
      }
    },
    {
      path: '/AutomaticShelving/captureTask',
      name: "captureTask",
      component: () => import("@/views/automaticShelving/captureTaskList/index.vue"),
      meta: {
        title: "抓取任务",
      }
    },
    {
      path: '/AutomaticShelving/deadlineExtension',
      name: "deadlineExtension",
      component: () => import("@/views/automaticShelving/deadlineExtension/index.vue"),
      meta: {
        title: "截单延期",
      }
    },
    //  {
    //   path: '/AutomaticShelving/qutboundShipment',
    //   name: "qutboundShipment",
    //   component: () => import("@/views/automaticShelving/qutboundShipment/index.vue"),
    //   meta: {
    //     title: "出荷",
    //   }
    //  },
    {
      path: '/AutomaticShelving/remainingPayment',
      name: "remainingPayment",
      component: () => import("@/views/automaticShelving/remainingPayment/index.vue"),
      meta: {
        title: "补尾款",
      }
    },
    {
      path: '/AutomaticShelving/waitOpenSpotGoods',
      name: "waitOpenSpotGoods",
      component: () => import("@/views/automaticShelving/waitOpenSpotGoods/index.vue"),
      meta: {
        title: "待开启现货",
      }
    },
    {
      path: '/AutomaticShelving/autoMessage',
      name: "autoMessage",
      component: () => import("@/views/automaticShelving/autoMessage/index.vue"),
      meta: {
        title: "批量留言",
      }
    },
  ]
}

export default automaticShelvingRouter;